import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { AnimateModule, SwiperDirective, WwwRouteSlug } from '@pro-connect/shared';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { title } from 'process';
import { Swiper, SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-account-home-top',
  templateUrl: './account-home-top.component.html',
  styleUrls: ['./account-home-top.component.scss'],
  imports: [CommonModule, NgOptimizedImage, AnimateModule, SwiperDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AccountHomeTopComponent {
  public readonly banners: WritableSignal<{ img: string; imgMob: string; title: string; desc: string }[]> = signal([
    {
      img: 'assets/images/pages/account/home/slide.webp',
      imgMob: 'assets/images/pages/account/home/slide-mob.webp',
      title: '',
      desc: `
        <p>
          Tu pasja spotyka się z biznesem. <br class='d-none d-md-inline'/>
          Rozwijaj swoje umiejętności, inspiruj się trendami i <br class='d-none d-md-inline'/>
          buduj silną markę wraz z L'Oréal. Dołącz do <br class='d-none d-md-inline'/>
          społeczności Pro.Connect i zyskaj:
        </p>
        <ul>
          <li>Wiedzę ekspertów z różnych branż.</li>
          <li>Dostęp do innowacyjnych narzędzi i rozwiązań.</li>
          <li>Wsparcie w rozwoju Twojego salonu.</li>
          <li>Możliwość networkingu z najlepszymi.</li>
        </ul>
      `,
    },
  ]);

  protected readonly WwwRouteSlug = WwwRouteSlug;
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public readonly activeSlideIndex = signal(0);
  public readonly swiperConfig: SwiperOptions = {
    spaceBetween: 35,
    slidesPerView: 1,
    freeMode: false,
    loop: true,
    updateOnWindowResize: true,
    pagination: {
      el: '.app-acc-hom-top__swi--pag',
      type: 'bullets',
      clickable: true,
    },
    on: {
      slideChange: (swiper: Swiper) => {
        this.activeSlideIndex.set(swiper.realIndex);
        // TO DO ADD GTM PUSH LAYER ON SLIDE CHANGE
      },
    },
  };

  public slieChangeLayer(pageCategory: string, slideTitle: string, destinationUrl: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: pageCategory,
      eventAction: `select::slider navigation`,
      eventLabel: `${slideTitle}::${destinationUrl}`,
      event_name: 'slider_button_click',
      cta_name: slideTitle,
      link_url: destinationUrl,
    });
  }

  public onSLideChangePushLayer($event: any): void {
    this.slieChangeLayer('range page', title, '');
  }
}
